/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const GET_CLAIM_AUDIT_SELECT_SCREEN_OBJ =
  'GET_CLAIM_AUDIT_SELECT_SCREEN_OBJ';
export const SET_CLAIM_AUDIT_SELECT_SCREEN_OBJ =
  'SET_CLAIM_AUDIT_SELECT_SCREEN_OBJ';
export const GET_ALL_LABELER = 'GET_ALL_LABELER';
export const GET_ERROR_MSG_FOR_CLAIM_AUDIT = 'GET_ERROR_MSG_FOR_CLAIM_AUDIT';
export const GET_REBATE_PROGRAM_DROPDOWN = 'GET_REBATE_PROGRAM_DROPDOWN';
export const GET_SPECIFIC_AUDIT_TYPE_DROPDOWN =
  'GET_SPECIFIC_AUDIT_TYPE_DROPDOWN';
export const CLAIM_CATEGORY_CD = 'CLAIM_CATEGORY_CD';
export const GET_CLAIM_AUDIT_DETAIL = 'GET_CLAIM_AUDIT_DETAIL';
export const GET_CLAIM_DETAILS = 'GET_CLAIM_DETAILS';
export const CLAIM_ACTIONS = 'CLAIM_ACTIONS';
export const GET_NDC_DETAILS = 'GET_NDC_DETAILS';
export const CLAIM_AUDIT_DETAILS = 'CLAIM_AUDIT_DETAILS';
export const CLAIM_AUDIT_DESCRIPTION = 'CLAIM_AUDIT_DESCRIPTION';
export const SEARCH_CLAIM_LIST = 'SEARCH_CLAIM_LIST';
export const CLAIM_AUDIT_DETAIL_TAB_DATA = 'CLAIM_AUDIT_DETAIL_TAB_DATA';
export const UPDATE_CLEARED_RESPONSE = 'UPDATE_CLEARED_RESPONSE';
export const GET_PAGE_COUNT = 'GET_PAGE_COUNT';
export const ROW_SELECTED = 'ROW_SELECTED';
export const SELECTED_AUDITTYPE = 'SELECTED_AUDITTYPE';
export const HANDLE_ERROR_MSG_CD = 'HANDLE_ERROR_MSG_CD';
export const GET_CLAIM_AUDIT_DETAIL_SCREEN_OBJ =
  'GET_CLAIM_AUDIT_DETAIL_SCREEN_OBJ';
export const GET_CLAIM_AUDIT_POPUP_COUNT = 'GET_CLAIM_AUDIT_POPUP_COUNT';
export const GET_PROVIDER_DETAILS = 'GET_PROVIDER_DETAILS';
export const GET_EXPORT_ALL_DETAIL = 'GET_EXPORT_ALL_DETAIL';
export const ALL_CHANGES_CLAIM_AUDITS_DATA_LIST =
  'ALL_CHANGES_CLAIM_AUDITS_DATA_LIST';
export const GET_FREEZE_QUARTER_FOR_CLAIM_AUDIT =
  'GET_FREEZE_QUARTER_FOR_CLAIM_AUDIT';
export const SET_EXPORT_HANDLER = 'SET_EXPORT_HANDLER';
